import { render } from "./HeroAuthProfile.vue?vue&type=template&id=470d52b2&scoped=true"
import script from "./HeroAuthProfile.vue?vue&type=script&lang=js"
export * from "./HeroAuthProfile.vue?vue&type=script&lang=js"

import "./HeroAuthProfile.vue?vue&type=style&index=0&id=470d52b2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-470d52b2"]])

export default __exports__